





























import * as d3 from 'd3';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { GeometryObject, GeoJsonProperties, Feature  } from 'geojson';
import { LocationData, RadarData } from './types';

@Component
export default class SwGeoMapCanvas extends Vue{
  cssPrefix:string = 'sw-geo-map-canvas';
  @Prop({
    type: Array,
    default() { return []; },
  })
  locationArray: LocationData[];
  @Prop({
    type: Array,
    default() { return []; },
  })
  radarArray: RadarData[];
  @Prop({
    type:Array,
    default() { return []; },
  })
  countryData: Feature<GeometryObject, GeoJsonProperties>[];

  @Prop({
    default() { return 'light'; },
  })
  theme: string;

  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  markerImg: HTMLImageElement = new Image();
  radarImg: HTMLImageElement = new Image();
  backCanvas: HTMLCanvasElement;
  backCtx: CanvasRenderingContext2D;
  requestAnimationFrame = window.requestAnimationFrame;
  myReq: number;

  projection = d3.geoEquirectangular()
                 .center([10, -4]);

  get geoPath() {
    return d3.geoPath()
             .projection(this.projection)
             .context(this.ctx);
  }

  get radarArrayCur () {
    return this.radarArray.slice(0);
  }

  @Watch('countryData')
  drawMap () {
    this.countryData.forEach((d:Feature<GeometryObject, GeoJsonProperties>) => {
      this.ctx.fillStyle = '#000000';
      this.ctx.strokeStyle = '#000000';
      this.ctx.beginPath();
      this.geoPath(d);
      this.ctx.fill();
      this.ctx.stroke();
    });

    if (this.countryData.length > 0) {
      this.markerImg.src = '../../../../static/map_cas.svg';
      this.markerImg.onload = () => {
        this.drawLocation();
      };

      this.radarImg.src = '../../../../static/map_cas.svg';
      this.radarImg.onload = () => {
        this.drawRadar();
      };
    }
  }

  @Watch('locationArray')
  drawLocation () {
    let i;
    for (i = 0 ; i < this.locationArray.length ; i += 1) {
      const location = this.coordinateToLocation(this.locationArray[i].coordinate);
      if (location != null) {
        this.locationArray[i].location = location;
        this.ctx.drawImage(this.markerImg, location[0] - 9.5, location[1] - 25, 17, 25);
      }
    }
  }

  @Watch('radarArray')
  drawRadar () {
    this.myReq = requestAnimationFrame(() => this.drawRadar());
    let i;
    this.backCtx.clearRect(0, 0, 950, 400);
    for (i = 0 ; i < this.radarArrayCur.length ; i += 1) {
      const location = this.coordinateToLocation(this.radarArrayCur[i].coordinate);
      let rotation = this.radarArrayCur[i].rotation;
      let radius = this.radarArrayCur[i].radius;
      let opacity;
      rotation = rotation === undefined ? 0 : rotation + 4;
      opacity = opacity === undefined ? 0.25 : opacity + 0.01;
      if (radius === undefined) {
        radius = 16;
      } else {
        radius = radius > 35 ? 16 : radius + 0.3;
      }
      opacity = radius < 20 ? 0 : (0.25 * radius) / 16 ;
      if (location != null) {
        this.radarArrayCur[i].location = location;
        this.radarArrayCur[i].radius = radius;
        this.radarArrayCur[i].translate = `translate(${location[0]},${location[1]})`;
        this.ctx.save();
        this.ctx.translate(location[0] , location[1]);
        this.ctx.rotate(rotation);
        this.ctx.drawImage(this.radarImg, -14 , -14 , 28, 28);
        this.ctx.restore();

        this.backCtx.beginPath();
        this.backCtx.save();
        this.backCtx.translate(location[0], location[1]);
        this.backCtx.globalAlpha = opacity;
        this.backCtx.arc(0, 0, radius, 0, Math.PI * 2);
        this.backCtx.closePath();
        this.backCtx.lineWidth =  radius < 26 ? 10 : 12;
        this.backCtx.strokeStyle = this.radarArrayCur[i].color;
        this.backCtx.stroke();
        this.backCtx.restore();
      }
    }
  }

  coordinateToLocation(coordinate:number[]) {
    const location = this.projection([coordinate[0], coordinate[1]]);
    return location;
  }

  mounted() {
    const canvasEl = this.$el.querySelector('canvas.sw-geo-map-canvas__main') as HTMLCanvasElement;
    const backCanvasEl =  this.$el.querySelector('canvas.sw-geo-map-canvas__animate') as HTMLCanvasElement;
    if (backCanvasEl != null) {
      this.backCanvas = backCanvasEl;
      const backCtx = this.backCanvas.getContext('2d');
      if (backCtx != null) {
        this.backCtx = backCtx;
      }
    }

    if (canvasEl != null) {
      this.canvas = canvasEl;
      const ctx = this.canvas.getContext('2d');
      if (ctx != null) {
        this.ctx = ctx;
        this.ctx.globalAlpha = 0.95;
        this.drawMap();
      }
    }
  }

  destroyed () {
    window.cancelAnimationFrame(this.myReq);
  }

}
